import React from 'react'
import grupo_1072 from '../images/homePage/Grupo_1072.png'
const BackgroundImage = () => {
    return (
        <div>
            <div>
                <svg className="Rectngulo_153_r">
                    <radialGradient id="Rectngulo_153_r" spreadMethod="pad" x1="0" x2="0" y1="0" y2="0">
                        <stop offset="0" stopColor="#e3c9ff" stopOpacity="1"></stop>
                        <stop offset="0.1105" stopColor="#dfbffe" stopOpacity="1"></stop>
                        <stop offset="0.2936" stopColor="#d4a6fd" stopOpacity="1"></stop>
                        <stop offset="0.5266" stopColor="#c37dfc" stopOpacity="1"></stop>
                        <stop offset="0.7976" stopColor="#ac44f9" stopOpacity="1"></stop>
                        <stop offset="1" stopColor="#9916f8" stopOpacity="1"></stop>
                    </radialGradient>
                    <rect id="Rectngulo_153_r" rx="0" ry="0" x="0" y="0" width="100%" height="100%">
                    </rect>
                </svg>
            </div>
            <div id="OBJECTS">
                <div id="Grupo_1073">
                    <img id="Grupo_1072" src={grupo_1072} alt="Grupo 1072" />
                </div>
            </div>
        </div>
    )
}

export default BackgroundImage
